export default __webpack_public_path__ + "static/logo-db1d956fdc61027f813a0abd0b6481dd.png";